import { axiosRequest } from '@/util/axios-request'
const ruleList = '/web/leave/setting_list'
const ruleInfoList = '/web/leave/setting_info'
const ruleAdd = '/web/leave/add_setting'
const ruleEdit = '/web/leave/edit_setting'
const ruleUrl = '/web/leave/del_setting'
const restList = '/web/leave/leave_days_list'
const restEditList = '/web/leave/edit_leave_days'
const supCard = '/web/attendance/reissue_setting'
const getSupCard = '/web/attendance/reissue_info'
const otTypes = '/web/apply/overtime_types'
const otInfo = '/web/apply/ot_setting_info'
const otAdd = '/web/apply/save_ot_setting'
const getSettingCycle = '/web/leave/get_setting_cycle'
const getTravel = '/web/apply/travelList'
const saveRule = '/web/apply/store'
const getDetail = '/web/apply/detail'
const outList = '/web/apply/list'
const senior = '/web/workflow/getAdvanceSetting'
const setSenior = '/web/workflow/saveAdvanceSetting'

const applyList = '/web/apply/list'
const addApply = '/web/apply/add'
const delApply = '/web/apply/del'
const editApply = '/web/apply/edit'
const detailApply = '/web/apply/detail'

// 请假-员工余额导出
export const exportLeaveDays = data => axiosRequest({ url: '/web/leave/exportLeaveDays', method: 'get' })
export const ruleListFn = data => axiosRequest({ url: ruleList, data })
export const ruleInfoListFn = data => axiosRequest({ url: ruleInfoList, data })
export const ruleAddFn = data => axiosRequest({ url: ruleAdd, data })
export const ruleEditFn = data => axiosRequest({ url: ruleEdit, data })
export const ruleFn = data => axiosRequest({ url: ruleUrl, data })
export const restListFn = data => axiosRequest({ url: restList, data })
export const restEditListFn = data => axiosRequest({ url: restEditList, data })
export const supCardFn = data => axiosRequest({ url: supCard, data })
export const getSupCardFn = data => axiosRequest({ url: getSupCard, data })
export const otTypesFn = data => axiosRequest({ url: otTypes, data })
export const otInfoFn = data => axiosRequest({ url: otInfo, data })
export const otAddFn = data => axiosRequest({ url: otAdd, data })
export const getSettingCycleFn = () => axiosRequest({ url: getSettingCycle })
export const getTravelFn = () => axiosRequest({ url: getTravel })
export const saveRuleFn = data => axiosRequest({ url: saveRule, data })
export const getDetailFn = data => axiosRequest({ url: getDetail, data })
export const outListFn = data => axiosRequest({ url: outList, data })
// 判断是否应该展示员工假期余额折算规则输入框
export const showConversionRateInput = data => axiosRequest({ url: '/web/leave/showConversionRateInput', data })
// 获取高级设置
export const getSenior = data => axiosRequest({ url: senior, data })
// 设置高级设置
export const setSeniorFn = data => axiosRequest({ url: setSenior, data })

// 获取加班规则列表
export const getApplyList = data => axiosRequest({ url: applyList, data })

// 新增加班规则
export const applyAdd = data => axiosRequest({ url: addApply, data })
// 删除加班规则
export const applyDel = data => axiosRequest({ url: delApply, data })

// 编辑加班规则
export const applyEdit = data => axiosRequest({ url: editApply, data })

// 考勤加班详情

export const applyDeyail = data => axiosRequest({ url: detailApply, data })
